<page-grid
  [gridConfig]="adxPaymentsGrid"
  (gridEvent)="handleCreatePaymentDialog()"
  (gridClickColumn)="handleIdClick($event)">
</page-grid>